import Button from "@components/ui/button";
import Icon from "@components/ui/icon";
import { useAppDispatch } from "@store";
import { openDialog } from "@store/dialogs";
import { useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import { useAuthStoreShallow } from "@/features/authentication";
import { useGetAccountQuery } from "@/shared/services";
import UpdateBillingDetailsDialog from "../components/update-billing-details-dialog";

export const useUpdateBillingErrorToast = () => {
  const { data: account } = useGetAccountQuery();
  const dispatch = useAppDispatch();
  const isAdministrator = useAuthStoreShallow(
    (state) => state.isAdminOrAdministrator,
  );
  const onContactUs = useCallback(() => {
    window.open("https://help.storydoc.com", "_blank");
  }, []);

  const onUpdateBillingDetails = useCallback(() => {
    dispatch(
      openDialog({
        id: "update-billing-details",
        content: UpdateBillingDetailsDialog,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (!account) return;
    const { plan, subscriptionStatus, paymentsUpdateUrl } = account;
    if (plan === "paid" && subscriptionStatus === "past_due") {
      const canUpgrade =
        isAdministrator && typeof paymentsUpdateUrl === "string";
      toast.error(
        <div className="tw-flex tw-items-center">
          <div className="tw-flex tw-flex-col tw-text-left tw-leading-tight">
            We couldn't process your latest payment.{" "}
            <span className="tw-font-light">
              Please update your billing details.
            </span>
          </div>
          <Button
            size="xs"
            variant="secondary"
            className="tw-ml-10"
            onClick={canUpgrade ? onUpdateBillingDetails : onContactUs}
          >
            {canUpgrade ? "Update billing" : "Contact us"}
          </Button>
          <button
            className="tw-ml-2 hover:tw-opacity-80 tw-transition-opacity tw-cursor-pointer"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              toast.dismiss();
            }}
          >
            <Icon icon="ri-close-fill" />
          </button>
        </div>,
        {
          autoClose: false,
          closeOnClick: false,
          toastId: "update-billing-error-toast",
        },
      );
    }
  }, [account, isAdministrator, onUpdateBillingDetails, onContactUs]);
};
